import { Typography } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import cn from 'classnames'
import { usePageHeaderContext } from 'components/PageHeader/PageHeaderContext'

const useStyles = makeStyles()(theme => ({
  container: {
    margin: theme.spacing(4, 0),
    padding: theme.spacing(0, 4),
  },
  defaultTheme: {
    '& .MuiTypography-root': {
      color: '#FFF',
    },
  },
}))

export interface IPageHeaderTextProps {
  children: React.ReactNode
}

const PageHeaderText = (props: IPageHeaderTextProps) => {
  const context = usePageHeaderContext()
  const { classes } = useStyles()
  const { children, ...restProps } = props

  return (
    <div
      className={cn(classes.container, {
        [classes.defaultTheme]: !context?.alternativeHeader,
      })}
      {...restProps}
    >
      <Typography variant="h4" component="div">
        {children}
      </Typography>
    </div>
  )
}

export default React.memo(PageHeaderText)
